const COMPANY_CONNECTORS = ['da', 'de', 'do', 'das', 'dos', 'e'];

const COMPANY_NAME_EXCEPTIONS: Record<string, string> = {
  rubervalcarvalhodeandrade: 'Mercearia Nossa Senhora Aparecida',
};

const COMPANY_DOMAIN_MARKERS = ['erp', 'gestao', 'app'];

const getSafeHostname = (value: string): string => {
  if (!value?.trim()) return '';

  try {
    const parsedUrl = new URL(
      value.startsWith('http') ? value : `https://${value}`,
    );

    return parsedUrl.hostname.toLowerCase();
  } catch {
    return value.toLowerCase().trim();
  }
};

const extractCompanySlugFromUrl = (value: string): string => {
  const hostname = getSafeHostname(value);

  if (!hostname) return '';

  const parts = hostname.split('.').filter(Boolean);

  const stopIndex = parts.findIndex((part) =>
    COMPANY_DOMAIN_MARKERS.includes(part),
  );

  if (stopIndex > 0) return parts.slice(0, stopIndex).join(' ');

  return parts[0] || '';
};

const sanitizeCompanyEdge = (value: string): string => {
  return value.replace(/^[^a-zA-ZÀ-ÿ]+/, '').replace(/[^a-zA-ZÀ-ÿ]+$/, '');
};

const normalizeCompanySuffixes = (value: string): string => {
  return value.replace(/\bs\.a\.?$/i, 'S.A.');
};

const toCompanyTitleCase = (value: string): string => {
  return value
    .split(/\s+/)
    .filter(Boolean)
    .map((word, index) => {
      const lowerWord = word.toLowerCase();

      if (index > 0 && COMPANY_CONNECTORS.includes(lowerWord)) return lowerWord;

      return lowerWord.charAt(0).toUpperCase() + lowerWord.slice(1);
    })
    .join(' ');
};

export const formatCompanyName = (
  value: string,
  fallbackName?: string,
): string => {
  const normalizedFallback = sanitizeCompanyEdge(fallbackName?.trim() || '')
    .replace(/\s+/g, ' ')
    .trim();

  if (normalizedFallback)
    return normalizeCompanySuffixes(toCompanyTitleCase(normalizedFallback));

  const slug = sanitizeCompanyEdge(extractCompanySlugFromUrl(value))
    .replace(/[-_.]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!slug) return '';

  const compactSlug = slug.replace(/\s+/g, '');

  if (COMPANY_NAME_EXCEPTIONS[compactSlug])
    return COMPANY_NAME_EXCEPTIONS[compactSlug];

  return normalizeCompanySuffixes(toCompanyTitleCase(slug));
};
